<template>
    <div class="empty-chart">
        <span class="icon-blocked empty-chart__icon"></span>
        <span v-html="$t('OrganizationReport.empty_dashboard')"></span>
    </div>
</template>

<script>
    export default {
        name: 'empty-chart'
    }
</script>

<style lang="scss" scoped>
.empty-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $gray;
    padding: 50px 0;

    &__icon {
        font-size: 4rem;
        margin: 0 0 20px;
    }
}
</style>
